import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppFormsModule } from '../../../forms/forms.module';
import { MaterialModule } from '../../../material.module';
import { SharedModule } from '../../../shared/shared.module';
import { SharedStockModule } from '../shared/shared.module';
import { DashboardActionsComponent } from './components/dashboard-actions/dashboard-actions.component';
import { DashboardQuickActionDialogComponent } from './components/dashboard-quick-action-dialog/dashboard-quick-action-dialog.component';
import { DashboardStockItemsComponent } from './components/dashboard-stock-items/dashboard-stock-items.component';

@NgModule({
  declarations: [DashboardActionsComponent, DashboardQuickActionDialogComponent, DashboardStockItemsComponent],
  imports: [
    AppFormsModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    SharedStockModule,
  ],
  exports: [DashboardActionsComponent],
})
export class StockDashboardModule {}
